import React, { useEffect, useState } from "react";

import api from "../axiosConfig";
import { getUser } from "../helpers";

const VanTargetRowData = (currency) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const user = getUser();

  useEffect(() => {
    const fetchData = (user) => {
      setLoading(true);
      api
        .get("/api/van/targets", {
          params: {
            user: user,
            currencyType: currency,
            page: "vantargets",
          },
        })
        .then((response) => {
          setData(response.data.Data || []);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching van target data:", error);
          setError(error);
          setLoading(false);
        });
    };

    fetchData(user);
  }, [currency]);

  return { loading, data };
};

export default VanTargetRowData;
